@use 'sass:color' as sassColor;
@use '../../styling/form-controls.scss' as *;
@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

$track-bg: sassColor.adjust($color-grey-B, $alpha: -0.75);

.InputRange {
  @extend %form-control-font;

  .Layout {
    display: flex;
    align-items: center;
    column-gap: 6px;
    color: $color-grey-B;
    min-height: $component-height;

    &.Disabled {
      pointer-events: none;
      opacity: 0.5;
    }

    input[type="number"] {
      font-weight: $font-weight-semibold;
      margin-right: 18px;
      max-width: 80px;
      height: 32px;
    }
  }

  input.RangeInput {
    appearance: none;
    width: 100%;
    height: 4px;
    background: $track-bg;
    outline: none;
    border-radius: 4px;
    accent-color: $color-primary-purple;
    cursor: pointer;

    &::-webkit-slider-thumb {
      appearance: none;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background: $theme-color-background;
      border: 2px solid $color-primary-purple;
      position: relative;
      top: -10px;
    }

    &::-webkit-slider-runnable-track {
      background: linear-gradient(to right, $color-primary-purple var(--progress, 0), $color-transparent var(--progress, 0));
      height: 4px;
      width: 100%;
      border-radius: 4px;
    }

    &::-moz-range-thumb {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background: $theme-color-background;
      border: 2px solid $color-primary-purple;
    }

    &::-moz-range-progress {
      background-color: $color-primary-purple;
      height: 4px;
      border-radius: 4px;
    }
  }

  .ErrorMessage {
    @extend %form-control-invalid-font;

    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    column-gap: 6px;
    padding: 8px 2px;
    font-size: $font-size-normal;

    .ErrorIcon {
      align-self: baseline;
      margin-top: 3px;
    }
  }
}
